import { render, staticRenderFns } from "./OriginatorForm.vue?vue&type=template&id=158114fe&scoped=true"
import script from "./OriginatorForm.vue?vue&type=script&lang=js"
export * from "./OriginatorForm.vue?vue&type=script&lang=js"
import style0 from "./OriginatorForm.vue?vue&type=style&index=0&id=158114fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158114fe",
  null
  
)

export default component.exports